export class ValidationError extends Error {
  constructor(message: string, public errors: Record<string, any>) {
    super(message);
  }
}
